import { isArray } from 'lodash'
import { apiPost, apiPatch, apiGet } from '@forwardflow/services/Axios/configs'
import { IPhoneNumber, ResponseSuccess } from '@forwardflow/types'

export class PhoneNumberManagementService {
   static async getPhoneNumbers() {
      const response = await apiGet<ResponseSuccess<IPhoneNumber[]>>({
         apiPath: '/phone-numbers/all',
      })
      return isArray(response?.data) ? response?.data : []
   }

   static async assignPhoneNumberToCampaign(
      phoneNumbers: string[],
      campaignId: string
   ) {
      const response = await apiPost<ResponseSuccess<any>>({
         apiPath: '/phone-numbers/assign-phone-numbers-to-campaign',
         data: {
            phoneNumbers,
            campaignId,
         },
      })
      return response.data
   }

   static async removePhoneNumbers(phoneNumbers: string[]) {
      const response = await apiPost({
         apiPath: '/phone-numbers/remove-phone-numbers',
         data: {
            phoneNumbers,
         },
      })
      return response
   }

   static async updateRealtorNumber(phoneNumber: string) {
      const response = await apiPatch<ResponseSuccess<any>>({
         apiPath: '/phone-numbers/update-ff-number',
         data: {
            phoneNumber,
         },
      })
      return response.data
   }

   static async purchasePhoneNumbers(orgId: string, phoneNumbers: string[]) {
      const response = await apiPost<ResponseSuccess<any>>({
         apiPath: '/subscriptions/subscribe-to-phone-numbers',
         data: {
            orgId,
            phoneNumbers,
         },
         includeXOrg: false,
      })
      return response.data
   }

   static async getPhoneNumberPricing(totalNumbers: number) {
      const response = await apiGet<ResponseSuccess<any>>({
         apiPath: `/phone-numbers/pricings?totalNumbers=${totalNumbers}`,
      })
      return response.data
   }
}

export const dummyPhoneNumbers = [
   {
      phoneNumber: {
         phoneNumber: '+17852687163',
         friendlyName: '(785) 268-7163',
         lata: '646',
         locality: 'South Franklin',
         rateCenter: 'SOFRANKLIN',
         latitude: null,
         longitude: null,
         region: 'KS',
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
         ffNumber: true,
         removeStatus: 'pending',
      },
      lastUpdated: '2025-12-18T19:51:57.251Z',
      campaignCount: 1,
      campaignIds: ['e78cb3322a92fc4583d5db13ef17a7e0'],
      campaigns: [
         {
            id: 'e78cb3322a92fc4583d5db13ef17a7e0',
            status: 'paused',
            campaignName: 'FF V222',
         },
      ],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+12015846036',
         friendlyName: '(201) 584-6036',
         lata: '224',
         locality: 'Hackensack',
         rateCenter: 'HACKENSACK',
         latitude: '40.885900',
         longitude: '-74.043500',
         region: 'NJ',
         postalCode: '07601',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
         ffNumber: false,
      },
      lastUpdated: '2025-12-18T19:50:31.445Z',
      campaignCount: 1,
      campaignIds: ['7141ec42281abefda1e1f5d1be80e15c'],
      campaigns: [
         {
            id: '7141ec42281abefda1e1f5d1be80e15c',
            status: 'draft',
            campaignName: 'Campaign 1',
         },
      ],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17197939624',
         friendlyName: '(719) 793-9624',
         lata: '658',
         locality: 'Leadville',
         rateCenter: 'LEADVILLE',
         latitude: '39.218500',
         longitude: '-106.360900',
         region: 'CO',
         postalCode: '80461',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:41.460Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17194097270',
         friendlyName: '(719) 409-7270',
         lata: '658',
         locality: 'Aguilar',
         rateCenter: 'AGUILAR',
         latitude: '37.454100',
         longitude: '-104.582600',
         region: 'CO',
         postalCode: '81020',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:41.204Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17192234538',
         friendlyName: '(719) 223-4538',
         lata: '658',
         locality: 'Walsh',
         rateCenter: 'WALSH',
         latitude: '37.318800',
         longitude: '-102.274200',
         region: 'CO',
         postalCode: '81090',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:40.951Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17067407982',
         friendlyName: '(706) 740-7982',
         lata: '438',
         locality: 'Summerville',
         rateCenter: 'SUMMERVL',
         latitude: '34.502800',
         longitude: '-85.301300',
         region: 'GA',
         postalCode: '30747',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:40.692Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17194175261',
         friendlyName: '(719) 417-5261',
         lata: '658',
         locality: 'Holly',
         rateCenter: 'HOLLY',
         latitude: '38.149800',
         longitude: '-102.267200',
         region: 'CO',
         postalCode: '81047',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:39.873Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+13202017606',
         friendlyName: '(320) 201-7606',
         lata: '628',
         locality: 'Rush City',
         rateCenter: 'RUSH CITY',
         latitude: '45.687400',
         longitude: '-92.948900',
         region: 'MN',
         postalCode: '55069',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:39.565Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17196314907',
         friendlyName: '(719) 631-4907',
         lata: '658',
         locality: 'Lake George',
         rateCenter: 'LAKEGEORGE',
         latitude: '39.044100',
         longitude: '-105.439900',
         region: 'CO',
         postalCode: '80827',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:39.250Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+16789710516',
         friendlyName: '(678) 971-0516',
         lata: '438',
         locality: 'Atlanta Northwest',
         rateCenter: 'ATLANTA NW',
         latitude: null,
         longitude: null,
         region: 'GA',
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:38.998Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+16788418407',
         friendlyName: '(678) 841-8407',
         lata: '438',
         locality: 'Atlanta Northeast',
         rateCenter: 'ATLANTA NE',
         latitude: null,
         longitude: null,
         region: 'GA',
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:38.746Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17196669179',
         friendlyName: '(719) 666-9179',
         lata: '658',
         locality: 'Lake George',
         rateCenter: 'LAKEGEORGE',
         latitude: '39.044100',
         longitude: '-105.439900',
         region: 'CO',
         postalCode: '80827',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:38.439Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17197677863',
         friendlyName: '(719) 767-7863',
         lata: '658',
         locality: 'Fowler',
         rateCenter: 'FOWLER',
         latitude: '38.129200',
         longitude: '-104.023300',
         region: 'CO',
         postalCode: '81039',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:38.107Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17194517309',
         friendlyName: '(719) 451-7309',
         lata: '658',
         locality: 'Cheraw',
         rateCenter: 'CHERAW',
         latitude: '38.106900',
         longitude: '-103.510200',
         region: 'CO',
         postalCode: '81030',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:37.825Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17196312263',
         friendlyName: '(719) 631-2263',
         lata: '658',
         locality: 'Ordway',
         rateCenter: 'ORDWAY',
         latitude: '38.396700',
         longitude: '-103.716000',
         region: 'CO',
         postalCode: '81063',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:37.517Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+19034194894',
         friendlyName: '(903) 419-4894',
         lata: '552',
         locality: 'Shirley',
         rateCenter: 'SHIRLEY',
         latitude: '33.052060',
         longitude: '-95.678570',
         region: 'TX',
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:37.189Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17403135643',
         friendlyName: '(740) 313-5643',
         lata: '324',
         locality: 'Dresden',
         rateCenter: 'DRESDEN',
         latitude: '40.143200',
         longitude: '-81.953000',
         region: 'OH',
         postalCode: '43821',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:36.903Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17198737813',
         friendlyName: '(719) 873-7813',
         lata: '658',
         locality: 'Two Buttes',
         rateCenter: 'TWO BUTTES',
         latitude: '37.612300',
         longitude: '-102.400300',
         region: 'CO',
         postalCode: '81084',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:36.597Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+19714334995',
         friendlyName: '(971) 433-4995',
         lata: '672',
         locality: 'Garibaldi',
         rateCenter: 'GARIBALDI',
         latitude: '45.559800',
         longitude: '-123.911000',
         region: 'OR',
         postalCode: '97118',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:36.288Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+12702356438',
         friendlyName: '(270) 235-6438',
         lata: '464',
         locality: 'Brownsville',
         rateCenter: 'BROWNSVL',
         latitude: '37.237500',
         longitude: '-86.334800',
         region: 'KY',
         postalCode: '42210',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:35.982Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+16812308085',
         friendlyName: '(681) 230-8085',
         lata: '254',
         locality: 'Union Ridge',
         rateCenter: 'UNIONRIDGE',
         latitude: null,
         longitude: null,
         region: 'WV',
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:35.675Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17196623014',
         friendlyName: '(719) 662-3014',
         lata: '658',
         locality: 'Alamosa',
         rateCenter: 'ALAMOSA',
         latitude: '37.469500',
         longitude: '-105.870000',
         region: 'CO',
         postalCode: '81101',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:35.367Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+16416329963',
         friendlyName: '(641) 632-9963',
         lata: '632',
         locality: 'Mystic',
         rateCenter: 'MYSTIC',
         latitude: '40.800600',
         longitude: '-92.969400',
         region: 'IA',
         postalCode: '52574',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:35.030Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+12186167959',
         friendlyName: '(218) 616-7959',
         lata: '636',
         locality: 'Baudette',
         rateCenter: 'BAUDETTE',
         latitude: '48.712500',
         longitude: '-94.599900',
         region: 'MN',
         postalCode: '56623',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:34.733Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+19174260025',
         friendlyName: '(917) 426-0025',
         lata: null,
         locality: null,
         rateCenter: null,
         latitude: null,
         longitude: null,
         region: null,
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:34.446Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+12183072028',
         friendlyName: '(218) 307-2028',
         lata: '624',
         locality: 'Coleraine',
         rateCenter: 'COLERAINE',
         latitude: '47.288800',
         longitude: '-93.427700',
         region: 'MN',
         postalCode: '55722',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:34.139Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17197497505',
         friendlyName: '(719) 749-7505',
         lata: '658',
         locality: 'Fairplay',
         rateCenter: 'FAIRPLAY',
         latitude: '39.228900',
         longitude: '-105.980900',
         region: 'CO',
         postalCode: '80440',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:33.808Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17198009861',
         friendlyName: '(719) 800-9861',
         lata: '658',
         locality: 'Leadville',
         rateCenter: 'LEADVILLE',
         latitude: '39.218500',
         longitude: '-106.360900',
         region: 'CO',
         postalCode: '80461',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:33.523Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17197877765',
         friendlyName: '(719) 787-7765',
         lata: '658',
         locality: 'Cheyenne Wells',
         rateCenter: 'CHEYENWLLS',
         latitude: '38.829500',
         longitude: '-102.451900',
         region: 'CO',
         postalCode: '80810',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:33.217Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17196285224',
         friendlyName: '(719) 628-5224',
         lata: '658',
         locality: 'Stratton',
         rateCenter: 'STRATTON',
         latitude: '39.304800',
         longitude: '-102.576000',
         region: 'CO',
         postalCode: '80836',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:32.909Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+12722362753',
         friendlyName: '(272) 236-2753',
         lata: '232',
         locality: 'Scranton',
         rateCenter: 'SCRANTON',
         latitude: '41.409000',
         longitude: '-75.662400',
         region: 'PA',
         postalCode: '18501',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:32.602Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17193474367',
         friendlyName: '(719) 347-4367',
         lata: '658',
         locality: 'Walsh',
         rateCenter: 'WALSH',
         latitude: '37.318800',
         longitude: '-102.274200',
         region: 'CO',
         postalCode: '81090',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:32.294Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+18102558634',
         friendlyName: '(810) 255-8634',
         lata: '340',
         locality: 'Montrose',
         rateCenter: 'MONTROSE',
         latitude: '43.190800',
         longitude: '-83.916700',
         region: 'MI',
         postalCode: '48457',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:31.988Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+19034146771',
         friendlyName: '(903) 414-6771',
         lata: '552',
         locality: 'Wolfe City',
         rateCenter: 'WOLFE CITY',
         latitude: '33.352300',
         longitude: '-96.053900',
         region: 'TX',
         postalCode: '75496',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:31.680Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+12184141741',
         friendlyName: '(218) 414-1741',
         lata: '624',
         locality: 'Hibbing',
         rateCenter: 'HIBBING',
         latitude: '47.427100',
         longitude: '-92.937700',
         region: 'MN',
         postalCode: '55746',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:31.356Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17179738050',
         friendlyName: '(717) 973-8050',
         lata: null,
         locality: null,
         rateCenter: null,
         latitude: null,
         longitude: null,
         region: 'PA',
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:31.066Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17243085534',
         friendlyName: '(724) 308-5534',
         lata: '234',
         locality: 'Aliquippa',
         rateCenter: 'ALIQUIPPA',
         latitude: '40.589000',
         longitude: '-80.327900',
         region: 'PA',
         postalCode: '15001',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:30.806Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+18104257244',
         friendlyName: '(810) 425-7244',
         lata: '340',
         locality: 'Port Sanilac',
         rateCenter: 'PT SANILAC',
         latitude: '43.445000',
         longitude: '-82.555700',
         region: 'MI',
         postalCode: '48469',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:30.555Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17196748875',
         friendlyName: '(719) 674-8875',
         lata: '658',
         locality: 'Rocky Ford',
         rateCenter: 'ROCKY FORD',
         latitude: '37.968900',
         longitude: '-103.749400',
         region: 'CO',
         postalCode: '81067',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:30.246Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+19713633430',
         friendlyName: '(971) 363-3430',
         lata: '672',
         locality: 'Detroit',
         rateCenter: 'DETROIT',
         latitude: '44.734000',
         longitude: '-122.149800',
         region: 'OR',
         postalCode: '97342',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:29.994Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17432720629',
         friendlyName: '(743) 272-0629',
         lata: null,
         locality: null,
         rateCenter: null,
         latitude: '0.000000',
         longitude: '0.000000',
         region: 'US',
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:29.223Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+19282912118',
         friendlyName: '(928) 291-2118',
         lata: '666',
         locality: 'Page',
         rateCenter: 'PAGE',
         latitude: '36.686700',
         longitude: '-111.415900',
         region: 'AZ',
         postalCode: '86040',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:28.915Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17194178531',
         friendlyName: '(719) 417-8531',
         lata: '658',
         locality: 'Las Animas',
         rateCenter: 'LAS ANIMAS',
         latitude: '38.066700',
         longitude: '-103.222700',
         region: 'CO',
         postalCode: '81054',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:28.608Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17197713395',
         friendlyName: '(719) 771-3395',
         lata: '658',
         locality: 'Manassa',
         rateCenter: 'MANASSA',
         latitude: '37.174200',
         longitude: '-105.937500',
         region: 'CO',
         postalCode: '81141',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:28.302Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+18143956645',
         friendlyName: '(814) 395-6645',
         lata: '140',
         locality: 'Shinglehouse',
         rateCenter: 'SHINGLEHOS',
         latitude: '41.928000',
         longitude: '-78.134200',
         region: 'PA',
         postalCode: '16748',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:27.994Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17196525885',
         friendlyName: '(719) 652-5885',
         lata: '658',
         locality: 'Howard',
         rateCenter: 'HOWARD',
         latitude: '38.435700',
         longitude: '-105.839400',
         region: 'CO',
         postalCode: '81233',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:27.687Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+19786435896',
         friendlyName: '(978) 643-5896',
         lata: '128',
         locality: 'Townsend',
         rateCenter: 'TOWNSEND',
         latitude: '42.659400',
         longitude: '-71.700500',
         region: 'MA',
         postalCode: '01469',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:27.380Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+14849150851',
         friendlyName: '(484) 915-0851',
         lata: '228',
         locality: 'Philadelphia Suburban Zone',
         rateCenter: 'PHPHSBZN11',
         latitude: null,
         longitude: null,
         region: 'PA',
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:27.094Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17197671709',
         friendlyName: '(719) 767-1709',
         lata: '658',
         locality: 'Holly',
         rateCenter: 'HOLLY',
         latitude: '38.149800',
         longitude: '-102.267200',
         region: 'CO',
         postalCode: '81047',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:26.827Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17194964911',
         friendlyName: '(719) 496-4911',
         lata: '658',
         locality: 'Salida',
         rateCenter: 'SALIDA',
         latitude: '38.561900',
         longitude: '-106.115300',
         region: 'CO',
         postalCode: '81201',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:26.575Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17197828334',
         friendlyName: '(719) 782-8334',
         lata: '658',
         locality: 'Two Buttes',
         rateCenter: 'TWO BUTTES',
         latitude: '37.612300',
         longitude: '-102.400300',
         region: 'CO',
         postalCode: '81084',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:26.322Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17194165468',
         friendlyName: '(719) 416-5468',
         lata: null,
         locality: null,
         rateCenter: null,
         latitude: '0.000000',
         longitude: '0.000000',
         region: 'US',
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:26.070Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17196281687',
         friendlyName: '(719) 628-1687',
         lata: '658',
         locality: 'Branson',
         rateCenter: 'BRANSON',
         latitude: '37.309300',
         longitude: '-103.732100',
         region: 'CO',
         postalCode: '81027',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:25.819Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17194174989',
         friendlyName: '(719) 417-4989',
         lata: '658',
         locality: 'South Fork',
         rateCenter: 'DEL NORTE',
         latitude: '37.648300',
         longitude: '-106.709100',
         region: 'CO',
         postalCode: '81154',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:25.566Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17198004343',
         friendlyName: '(719) 800-4343',
         lata: '658',
         locality: 'Springfield',
         rateCenter: 'SPRINGFLD',
         latitude: '37.411000',
         longitude: '-102.619600',
         region: 'CO',
         postalCode: '81073',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:25.309Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17192233756',
         friendlyName: '(719) 223-3756',
         lata: '658',
         locality: 'Salida',
         rateCenter: 'SALIDA',
         latitude: '38.561900',
         longitude: '-106.115300',
         region: 'CO',
         postalCode: '81201',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:25.056Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17179067251',
         friendlyName: '(717) 906-7251',
         lata: '226',
         locality: 'Mcveytown',
         rateCenter: 'MCVEYTOWN',
         latitude: '40.479500',
         longitude: '-77.786400',
         region: 'PA',
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:24.804Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17193264612',
         friendlyName: '(719) 326-4612',
         lata: '658',
         locality: 'Walsh',
         rateCenter: 'WALSH',
         latitude: '37.318800',
         longitude: '-102.274200',
         region: 'CO',
         postalCode: '81090',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:24.552Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+19175407898',
         friendlyName: '(917) 540-7898',
         lata: null,
         locality: null,
         rateCenter: null,
         latitude: null,
         longitude: null,
         region: null,
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:24.298Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+18553044435',
         friendlyName: '(855) 304-4435',
         lata: null,
         locality: null,
         rateCenter: null,
         latitude: null,
         longitude: null,
         region: null,
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:24.000Z',
      campaignCount: 1,
      campaignIds: ['82728d352e2657f1252779e78595f9f0'],
      campaigns: [
         {
            id: '82728d352e2657f1252779e78595f9f0',
            status: 'paused',
            campaignName: 'Demo Source',
         },
      ],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+14582046229',
         friendlyName: '(458) 204-6229',
         lata: null,
         locality: null,
         rateCenter: null,
         latitude: '0.000000',
         longitude: '0.000000',
         region: 'US',
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:23.740Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17197927028',
         friendlyName: '(719) 792-7028',
         lata: '658',
         locality: 'Monte Vista',
         rateCenter: 'MONTEVISTA',
         latitude: '37.560200',
         longitude: '-106.139200',
         region: 'CO',
         postalCode: '81144',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:23.488Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+16083878350',
         friendlyName: '(608) 387-8350',
         lata: '354',
         locality: 'Poynette',
         rateCenter: 'POYNETTE',
         latitude: '43.393800',
         longitude: '-89.396800',
         region: 'WI',
         postalCode: '53955',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:23.182Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17196268791',
         friendlyName: '(719) 626-8791',
         lata: '658',
         locality: 'Monte Vista',
         rateCenter: 'MONTEVISTA',
         latitude: '37.560200',
         longitude: '-106.139200',
         region: 'CO',
         postalCode: '81144',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:22.876Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17196622389',
         friendlyName: '(719) 662-2389',
         lata: '658',
         locality: 'Limon',
         rateCenter: 'LIMON',
         latitude: '39.263900',
         longitude: '-103.692200',
         region: 'CO',
         postalCode: '80826',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:22.622Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17196283809',
         friendlyName: '(719) 628-3809',
         lata: '658',
         locality: 'Stratton',
         rateCenter: 'STRATTON',
         latitude: '39.304800',
         longitude: '-102.576000',
         region: 'CO',
         postalCode: '80836',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:22.361Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+13159983930',
         friendlyName: '(315) 998-3930',
         lata: '136',
         locality: 'Belleville',
         rateCenter: 'BELLEVILLE',
         latitude: '43.778000',
         longitude: '-76.125900',
         region: 'NY',
         postalCode: '13611',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:22.056Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+16203123723',
         friendlyName: '(620) 312-3723',
         lata: null,
         locality: null,
         rateCenter: null,
         latitude: null,
         longitude: null,
         region: 'KS',
         postalCode: null,
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:21.748Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17193412533',
         friendlyName: '(719) 341-2533',
         lata: '658',
         locality: 'Branson',
         rateCenter: 'BRANSON',
         latitude: '37.309300',
         longitude: '-103.732100',
         region: 'CO',
         postalCode: '81027',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:21.441Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17197338646',
         friendlyName: '(719) 733-8646',
         lata: '658',
         locality: 'Salida',
         rateCenter: 'SALIDA',
         latitude: '38.561900',
         longitude: '-106.115300',
         region: 'CO',
         postalCode: '81201',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:21.136Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17198009411',
         friendlyName: '(719) 800-9411',
         lata: '658',
         locality: 'Trinidad',
         rateCenter: 'TRINIDAD',
         latitude: '37.169500',
         longitude: '-104.500500',
         region: 'CO',
         postalCode: '81082',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:20.798Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+18037704846',
         friendlyName: '(803) 770-4846',
         lata: '434',
         locality: 'Branchville',
         rateCenter: 'BRANCHVL',
         latitude: '33.232600',
         longitude: '-80.822400',
         region: 'SC',
         postalCode: '29432',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:20.051Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17192203340',
         friendlyName: '(719) 220-3340',
         lata: '658',
         locality: 'Saguache',
         rateCenter: 'SAGUACHE',
         latitude: '38.126300',
         longitude: '-106.236300',
         region: 'CO',
         postalCode: '81149',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:19.784Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17622252152',
         friendlyName: '(762) 225-2152',
         lata: '442',
         locality: 'Augusta',
         rateCenter: 'AUGUSTA',
         latitude: '33.471000',
         longitude: '-81.974800',
         region: 'GA',
         postalCode: '30901',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:19.528Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17194179568',
         friendlyName: '(719) 417-9568',
         lata: '658',
         locality: 'Manassa',
         rateCenter: 'MANASSA',
         latitude: '37.174200',
         longitude: '-105.937500',
         region: 'CO',
         postalCode: '81141',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:19.277Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17192590302',
         friendlyName: '(719) 259-0302',
         lata: '658',
         locality: 'Colorado Springs',
         rateCenter: 'COLORDOSPG',
         latitude: '38.833900',
         longitude: '-104.821400',
         region: 'CO',
         postalCode: '80901',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:19.025Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17193995706',
         friendlyName: '(719) 399-5706',
         lata: '658',
         locality: 'Rocky Ford',
         rateCenter: 'ROCKY FORD',
         latitude: '37.968900',
         longitude: '-103.749400',
         region: 'CO',
         postalCode: '81067',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-18T18:57:18.773Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17198884823',
         friendlyName: '(719) 888-4823',
         lata: '658',
         locality: 'Colorado Springs',
         rateCenter: 'COLORDOSPG',
         latitude: '38.833900',
         longitude: '-104.821400',
         region: 'CO',
         postalCode: '80901',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
         ffNumber: false,
      },
      lastUpdated: '2025-12-18T16:20:07.107Z',
      campaignCount: 1,
      campaignIds: ['e16d14d188a3e7f9f175166a743cd458'],
      campaigns: [
         {
            id: 'e16d14d188a3e7f9f175166a743cd458',
            status: 'paused',
            campaignName: 'Sales Demo',
         },
      ],
      engagedConversations: 2,
      conversationStats: {
         avgResponseRate: 475,
         totalMessages: 38,
         totalIncoming: 7,
         totalOutgoing: 31,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+17197355868',
         friendlyName: '(719) 735-5868',
         lata: '658',
         locality: 'Westcliffe',
         rateCenter: 'WESTCLIFFE',
         latitude: '38.077400',
         longitude: '-105.459900',
         region: 'CO',
         postalCode: '81252',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'purchased',
      },
      lastUpdated: '2025-12-11T20:36:05.043Z',
      campaignCount: 1,
      campaignIds: ['e78cb3322a92fc4583d5db13ef17a7e0'],
      campaigns: [
         {
            id: 'e78cb3322a92fc4583d5db13ef17a7e0',
            status: 'paused',
            campaignName: 'FF V222',
         },
      ],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+13148865836',
         friendlyName: '(314) 886-5836',
         lata: null,
         locality: 'SAINT LOUIS',
         rateCenter: null,
         latitude: null,
         longitude: null,
         region: 'US',
         postalCode: '63102',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'reserved',
      },
      lastUpdated: '2025-11-25T16:08:41.206Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+13149120467',
         friendlyName: '(314) 912-0467',
         lata: null,
         locality: 'SAINT LOUIS',
         rateCenter: null,
         latitude: null,
         longitude: null,
         region: 'US',
         postalCode: '63102',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'reserved',
      },
      lastUpdated: '2025-11-25T16:08:39.781Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
   {
      phoneNumber: {
         phoneNumber: '+13613065151',
         friendlyName: '(361) 306-5151',
         lata: '564',
         locality: 'Portland Gregory',
         rateCenter: 'PORTLDGGRY',
         latitude: null,
         longitude: null,
         region: 'TX',
         postalCode: '',
         isoCountry: 'US',
         addressRequirements: 'none',
         beta: false,
         capabilities: {
            voice: true,
            SMS: true,
            MMS: true,
         },
         status: 'reserved',
      },
      lastUpdated: '2025-11-25T16:08:22.577Z',
      campaignCount: 0,
      campaignIds: [],
      campaigns: [],
      engagedConversations: 0,
      conversationStats: {
         avgResponseRate: 0,
         totalMessages: 0,
         totalIncoming: 0,
         totalOutgoing: 0,
      },
   },
]
